import type { GlobalAsset, SrmProject } from '@types';
import { dashboardCountry } from './clientDashboardCountries';

const normalizedAddress = (value?: string) => (value || '').trim().toLowerCase().replace(/\s+/g, ' ');

const countryIso3 = (code?: string, name?: string) => dashboardCountry(code)?.iso3 || dashboardCountry(name)?.iso3;

export function countryFacilities(assets: GlobalAsset[], iso3: string): GlobalAsset[] {
    return assets.filter(asset => asset.type === 'Facility' && countryIso3(asset.iso3, asset.country) === iso3);
}

export function facilityFramework(projects: SrmProject[], asset: GlobalAsset, organizationId: string, iso3: string): SrmProject | undefined {
    const address = normalizedAddress(asset.location?.address);
    let newest: SrmProject | undefined;
    for (const project of projects) {
        if (project.organizationId !== organizationId || project.status === 'Archived' || String(project.status) === 'Error')
            continue;
        let matches = project.assetId === asset.id;
        if (!matches && !project.assetId && address) {
            const location = project.modules?.find(module => module.prefillData?.location_address)?.prefillData;
            const projectAddress = normalizedAddress(project.locationAddress || location?.location_address || location?.address);
            const projectCountry = countryIso3(project.iso3 || location?.iso3, project.country || location?.location_country || location?.country);
            matches = projectAddress === address && projectCountry === iso3;
        }
        if (matches && (!newest || Date.parse(project.createdAt) > Date.parse(newest.createdAt)))
            newest = project;
    }
    return newest;
}
